module.exports = __webpack_public_path__ + "img/activate_guide_2.336378e9.jpg";